import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TimeFrameItemProps } from "apis/time-frame";
import { PaginationProps } from "utils/types/API";

export interface TimeFrameState {
    loading: boolean;
    list: {
        data: TimeFrameItemProps[];
        options: TimeFrameItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: TimeFrameItemProps;
    };
}

const initialState: TimeFrameState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: TimeFrameItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: TimeFrameItemProps;
}
export const timeFrameSlice = createSlice({
    name: "time-frame",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = timeFrameSlice.actions;
export default timeFrameSlice.reducer;
